import { RESTRICTED_REGION_MESSAGE } from '@/lib/compliance/restricted-region';

export function UnsupportedRegionPage() {
  return (
    <div className="min-h-screen bg-white px-4">
      <div className="mx-auto flex min-h-screen w-full max-w-md items-center">
        <div className="space-y-3">
          <p className="text-sm font-medium uppercase tracking-[0.18em] text-slate-500">
            Unsupported Region
          </p>
          <h1 className="text-3xl font-semibold text-slate-950">
            Access unavailable
          </h1>
          <div className="space-y-1">
            <p className="text-base leading-7 text-slate-600">
              {RESTRICTED_REGION_MESSAGE}
            </p>
            <p className="text-base leading-7 text-slate-600">
              If you believe this is an error, please contact the Den team at{' '}
              <a
                className="underline underline-offset-2"
                href="mailto:support@onchainden.com"
              >
                support@onchainden.com
              </a>
              .
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
